import React, { useEffect } from 'react';
import styles from './UninstallPage.module.scss';
import Logo from '../../../common/assets/Logotype-Colored.svg';
import { Icon } from '../../../engage/components/Icon';
import { CustomButton } from '../../../engage/components/Button/Button';
import configs from '../../../../conf';
import { isChrome, isEdge } from 'react-device-detect';
const config = configs[process.env.APP_CONF];

function UninstallPage(props) {
  const redirect = () => {
    if (isChrome) window.location = config.chromeWebStoreUrl;
    if (isEdge) window.location = config.edgeWebStoreUrl;
  };

  useEffect(() => {
    const isClipRecording = localStorage.getItem('isClipRecording');
    if (isClipRecording) {
      localStorage.setItem('isClipRecording', false);
      localStorage.removeItem('draftSceneId');
    }
  }, []);

  return (
    <div>
      <div className={styles.logoContainer}>
        <div className={styles.logo} onClick={() => props.history.push('/eg/home')}>
          <img src={Logo} alt="VormatsLogo" />
        </div>
      </div>
      <div className={styles.content}>
        <Icon src="NotFound" />
        <span className={styles.message}>We're sorry to see you go :( We miss you already!</span>
        <CustomButton label="Reinstall Vormats" variant="primary" onClick={redirect} />
      </div>
    </div>
  );
}

export default UninstallPage;
